import { render, staticRenderFns } from "./IndirectCreditorsList.vue?vue&type=template&id=a2cbc812"
import script from "./IndirectCreditorsList.vue?vue&type=script&lang=js"
export * from "./IndirectCreditorsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports